<h2 mat-dialog-title>
    <mat-icon class="title-icon">file_download</mat-icon>
    Export Preview
</h2>

<mat-dialog-content>
    <!-- Summary stats -->
    <div class="stats-grid" *ngIf="!exportComplete && !exportError">
        <div class="stat-card">
            <div class="stat-value">{{ totalPromptSets }}</div>
            <div class="stat-label">Prompt {{ totalPromptSets === 1 ? 'Set' : 'Sets' }}</div>
        </div>
        <div class="stat-card">
            <div class="stat-value">{{ totalPrompts }}</div>
            <div class="stat-label">Total {{ totalPrompts === 1 ? 'Prompt' : 'Prompts' }}</div>
        </div>
        <div class="stat-card">
            <div class="stat-value">{{ setsWithOutputSchema }}</div>
            <div class="stat-label">With Output Schema</div>
        </div>
        <div class="stat-card">
            <div class="stat-value">{{ publishedSets }}</div>
            <div class="stat-label">Published</div>
        </div>
    </div>

    <!-- Detail list -->
    <div class="detail-section" *ngIf="!exportComplete && !exportError">
        <h4>Included Prompt Sets</h4>
        <div class="prompt-set-list">
            <div class="prompt-set-item" *ngFor="let ps of data.promptSets">
                <mat-icon class="item-icon" [class.published]="ps.published">
                    {{ ps.published ? 'check_circle' : 'radio_button_unchecked' }}
                </mat-icon>
                <div class="item-info">
                    <span class="item-name">{{ ps.name }}</span>
                    <span class="item-meta">
                        {{ ps.prompts?.length || 0 }} prompt{{ (ps.prompts?.length || 0) === 1 ? '' : 's' }}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <p class="note" *ngIf="!exportComplete && !exportError">
        The export will include prompts, output schemas, and summary prompts (if defined) for each prompt set.
    </p>

    <!-- Exporting state -->
    <div class="status-section" *ngIf="isExporting">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <p class="status-text">Exporting data... This may take a moment.</p>
    </div>

    <!-- Success state -->
    <div class="status-section success" *ngIf="exportComplete">
        <mat-icon class="status-icon success-icon">check_circle</mat-icon>
        <p class="status-text">Export completed successfully! The file has been downloaded.</p>
    </div>

    <!-- Error state -->
    <div class="status-section error" *ngIf="exportError">
        <mat-icon class="status-icon error-icon">error</mat-icon>
        <p class="status-text">Export failed. Please try again.</p>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="close()" [disabled]="isExporting">
        {{ exportComplete ? 'Done' : 'Cancel' }}
    </button>
    <button mat-flat-button color="primary"
            (click)="startExport()"
            [disabled]="isExporting || exportComplete"
            *ngIf="!exportComplete">
        <mat-icon *ngIf="!isExporting">file_download</mat-icon>
        <mat-icon *ngIf="isExporting">hourglass_empty</mat-icon>
        {{ isExporting ? 'Exporting...' : 'Export' }}
    </button>
</mat-dialog-actions>
